module.exports = __webpack_public_path__ + "mainassets/img/bg-graphic.c36aa99e.png";